import SprAPI from "@/api/SprAPI";
import {idUserForApi, typeRequestNameForApi, typesContact} from "@/controllers/UserController";


class SprController {
    constructor() {
        this.api = SprAPI;
    }


    _checkTypeContact(typeContact) {
        if (!typesContact[typeContact])
            throw new Error('type contact invalid can be founder or region;');
    }

    _checkId(id) {
        if (!id)
            throw new Error('id cannot be null');
    }

    /**
     * @param { 'founder' | 'region' } [typeContact]
     * @description get CO and Regions info
     * */
    async getCOsOrRegionsInfo(typeContact) {
        try {
            typeContact = typeContact ?? typeRequestNameForApi(typeContact);
            this._checkTypeContact(typeContact);
            const res = await this.api.getFoundersOrRegionsInfo(typeContact);
            return res.data
        } catch (e) {
            console.error('error getFoundersOrRegionsInfo ' + e)
            throw new Error('error getFoundersOrRegionsInfo ' + e)
        }
    }

    async getKcpGroups() {
        try {
            const res = await this.api.getKcpGroups();
            return res.data
        } catch (e) {
            console.error('error getKcpGroups ' + e)
            throw new Error('error getKcpGroups ' + e)
        }
    }

    /**
     * @param {['usls', 'fo', 'spec', 'orgs', 'indicators', 'founders']} names name spr in state in spr.js
     * */
    async getSprForOrganization(names = []) {
        try {
            if (!names.length)
                return;
            const namesForApi = names.map(el => ({name: el, apiName: `get${el[0].toUpperCase()}${el.slice(1)}`}));
            const requests = namesForApi.map(async el => await ({...el, data: await this.api[el.apiName]()}));
            const res = await Promise.allSettled(requests);
            return res.map(el => {
                if (el.value)
                    return {name: el.value.name, value: el.value.data?.data}
            });

        } catch (e) {
            console.error('error getSprForOrganization ' + e)
            throw new Error('error getSprForOrganization ' + e)
        }
    }
    /**
     * @param {number} [orgId]
     * */
    async getSprByOwnerId(orgId) {
        try {
            orgId = orgId ?? idUserForApi(orgId);
            this._checkId(orgId);
            const res = await this.api.getOrgsByOwner(orgId);
            return res.data.filter(el => el.status.id === 1);
        } catch (e) {
            console.error('error getSprForOrganization ' + e)
            throw new Error('error getSprForOrganization ' + e)
        }
    }
}

export default new SprController();